export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SET_USER = 'SET_USER';
export const SET_CONFIG = 'SET_CONFIG';
export const PUSH_ALERT = 'PUSH_ALERT';
